import { createStyles, makeStyles } from '@material-ui/core';

import { colorVariables } from '../../../styles/colorVariables';
import { Sizes } from '../../../styles/sizes';

export const useStyles = makeStyles((theme) =>
  createStyles({
    accountContainer: {
      paddingTop: 63,
      backgroundColor: colorVariables.white,
      [theme.breakpoints.down(Sizes.desktop)]: {
        padding: '70px 0 0 94px',
      },
      [theme.breakpoints.down(Sizes.mobile)]: {
        padding: '110px 0 80px 0',
      },
    },
    accountContainerCustomer: {
      [theme.breakpoints.between(Sizes.mobile, Sizes.desktop)]: {
        padding: '50px 0 0 0',
      },
    },
    accountHeader: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'flex-end',
      backgroundColor: colorVariables.white,
      height: 127,
      borderBottom: `1px solid ${colorVariables.steelGrey}`,
      paddingBottom: 30,
      paddingLeft: 55,
      paddingRight: 55,
      [theme.breakpoints.down(Sizes.desktop)]: {
        display: 'none',
      },
    },
    accountTitle: {
      fontSize: 32,
      lineHeight: '50px',
      fontWeight: 700,
    },
    accountBody: {
      display: 'flex',
    },
    accountContent: {
      width: '100%',
      padding: '25px 0px 50px 50px',
      [theme.breakpoints.down(Sizes.desktop)]: {
        width: '100%',
        padding: '40px 50px',
      },
      [theme.breakpoints.down(Sizes.tablet)]: {
        padding: 40,
      },
      [theme.breakpoints.down(Sizes.mobile)]: {
        padding: 24,
        paddingTop: 0,
      },
    },
    title: {
      fontSize: 24,
      lineHeight: '36px',
      fontWeight: 700,
      marginBottom: 30,
      [theme.breakpoints.down(Sizes.desktop)]: {
        display: 'none',
      },
    },
    formBox: {
      width: '100%',
    },
    tabletTitleCustomer: {
      paddingBottom: 20,
      marginBottom: 30,
      '&:after': {
        content: '""',
        display: 'block',
        position: 'absolute',
        width: '100vw',
        height: 1,
        right: 0,
        left: 0,
        transform: 'translateY(20px)',
        backgroundColor: colorVariables.steelGrey,
      },
    },
    fieldWrap: {
      width: '48%',
      marginBottom: 15,
      [theme.breakpoints.down(Sizes.mobile)]: {
        width: '100%',
        '&:first-child': {
          marginRight: 0,
        },
      },
    },
    btnBox: {
      marginTop: 25,
      display: 'flex',
      justifyContent: 'left',
      paddingBottom: 30,
    },
    userId: {
      fontSize: 16,
      color: colorVariables.navy,
    },
    services: {
      textAlign: 'center',
      margin: '0 auto',
      [theme.breakpoints.down(Sizes.mobile)]: {
        display: 'block',
      },
    },
    serviceItem: {
      width: '100%',
      [theme.breakpoints.down(Sizes.mobile)]: {
        marginBottom: 20,
      },
    },
    serviceAction: {
      '&.MuiCardActions-root': {
        display: 'block',
        padding: 0,
      }
    },
    logo: {
      minHeight: 65,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
    logoText: {
      minHeight: 12,
      fontSize: 12,
      fontWeight: 300,
      height: 38,
      padding: '0 16px',
    },
    logoText2: {
      fontSize: 14,
      fontWeight: 600,
      height: 38,
    },
    logoBtn: {
      marginTop: 10,
    },
    contactUs: {
      textAlign: 'center',
      marginTop: 100,
    },
    connected: {
      backgroundColor: colorVariables.blue,
      '&:hover': {
        backgroundColor: colorVariables.blue,
      }
    },
    card: {
      width: 216,
      marginRight: 10,
      marginBottom: 20,
      background: '#fff',
      border: '1px solid rgba(152, 165, 183, 0.15)',
      boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.05)',
      borderRadius: 10,
      paddingBottom: 16,
      '& .MuiCardContent-root': {
        padding: 0,
      },
      [theme.breakpoints.down(Sizes.mobile)]: {
        width: '100%',
        paddingBottom: 0,
      },
    }
  }),
);
